import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { Button } from '@/common/components/button';
import { MobileAppButtons } from '@/common/components/mobile-app-buttons';
import { Phototron } from '@/common/components/phototron';
import { redirect } from '@/common/utils';
import { getLoginPageUrl } from '@/core/services/authentication';
import { styles } from './styles';

export const VoucherRedeemPage: FC = () => {
  const [t] = useTranslation();
  const history = useHistory();

  const goToExternalLoginPage = useCallback(() => redirect(getLoginPageUrl()), [history]);

  return (
    <div css={styles}>
      <Phototron />

      <h2 className='title'>{t('page.voucherLanding.title')}</h2>

      <div className='description'>{t('page.voucherLanding.prompt')}</div>

      <Button theme='error' className='button' onClick={goToExternalLoginPage}>
        {t('button.createFreeAccount')}
      </Button>

      <Button className='button' onClick={goToExternalLoginPage}>
        {t('button.existingCustomersLogin')}
      </Button>

      <div className='description'>{t('page.voucherLanding.followUp')}</div>

      <MobileAppButtons />
    </div>
  );
};
